"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Input = _interopRequireDefault(require("../Input"));

var _InputGroup = _interopRequireDefault(require("../InputGroup"));

var _CheckboxGroup = _interopRequireDefault(require("../CheckboxGroup"));

var _RadioGroup = _interopRequireDefault(require("../RadioGroup"));

var _Select = _interopRequireDefault(require("../Select"));

var _Slider = _interopRequireDefault(require("../Slider"));

var _Multiplier = _interopRequireDefault(require("../Multiplier"));

var _CheckboxInput = _interopRequireDefault(require("../CheckboxInput"));

var _DatePicker = _interopRequireDefault(require("../DatePicker"));

var _SwitchInput = _interopRequireDefault(require("../SwitchInput"));

var FIELD_MAP = {
  text: _Input.default,
  inputGroup: _InputGroup.default,
  checkbox: _CheckboxInput.default,
  checkboxGroup: _CheckboxGroup.default,
  radioGroup: _RadioGroup.default,
  select: _Select.default,
  slider: _Slider.default,
  multiplier: _Multiplier.default,
  date: _DatePicker.default,
  switch: _SwitchInput.default
};

function FieldControl(_ref) {
  var overridesProp = _ref.overrides,
      classNameProp = _ref.className,
      labelMode = _ref.labelMode,
      isFullWidth = _ref.isFullWidth,
      isReadOnly = _ref.isReadOnly,
      field = _ref.field,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      onEnter = _ref.onEnter,
      value = _ref.value,
      error = _ref.error,
      customFields = _ref.customFields,
      isBulk = _ref.isBulk,
      bulkEditLabel = _ref.bulkEditLabel,
      bulkCancelLabel = _ref.bulkCancelLabel,
      onBulkEdit = _ref.onBulkEdit,
      onBulkCancel = _ref.onBulkCancel,
      props = (0, _objectWithoutProperties2.default)(_ref, ["overrides", "className", "labelMode", "isFullWidth", "isReadOnly", "field", "onChange", "onFocus", "onBlur", "onEnter", "value", "error", "customFields", "isBulk", "bulkEditLabel", "bulkCancelLabel", "onBulkEdit", "onBulkCancel"]);
  var onChangeField = (0, _react.useCallback)(function (input) {
    var value = input && input.target ? input.target.value : input;
    onChange && onChange(value, field);
  }, [onChange, field]);
  var onFocusField = (0, _react.useCallback)(function (input) {
    var value = input && input.target ? input.target.value : input;
    onFocus && onFocus(value, field);
  }, [onFocus, field]);
  var onBlurField = (0, _react.useCallback)(function (input) {
    var value = input && input.target ? input.target.value : input;
    onBlur && onBlur(value, field);
  }, [onBlur, field]);
  var onEnterField = (0, _react.useCallback)(function (input) {
    var value = input && input.target ? input.target.value : input;
    onEnter && onEnter(value, field);
  }, [onEnter, field]);
  var onBulkEditField = (0, _react.useCallback)(function (f) {
    return onBulkEdit && onBulkEdit(field);
  }, [onBulkEdit, field]);
  var onBulkCancelField = (0, _react.useCallback)(function (f) {
    return onBulkCancel && onBulkCancel(field);
  }, [onBulkCancel, field]);
  if (!field || !field.type) return null;
  var Field = FIELD_MAP[field.type];
  var component = customFields && customFields[field.type];
  if (!Field && component) Field = _Input.default;
  if (!Field) return null;
  var fieldProps = (0, _extends2.default)({}, field, {
    labelMode: labelMode,
    isFullWidth: isFullWidth,
    isReadOnly: isReadOnly,
    onEnter: onEnterField,
    onChange: onChangeField,
    onFocus: onFocusField,
    onBlur: onBlurField,
    className: classNameProp,
    value: value,
    error: error,
    customFields: customFields,
    component: component,
    isBulk: isBulk,
    bulkEditLabel: bulkEditLabel,
    bulkCancelLabel: bulkCancelLabel,
    onBulkEdit: onBulkEditField,
    onBulkCancel: onBulkCancelField,
    overrides: overridesProp
  });
  var attrs = field.attrs || {};
  return /*#__PURE__*/_react.default.createElement(Field, (0, _extends2.default)({}, fieldProps, attrs));
}

FieldControl.defaultProps = {
  labelMode: 'horizontal',
  isFullWidth: false,
  error: '',
  field: {}
};
process.env.NODE_ENV !== "production" ? FieldControl.propTypes = {
  /** Native form class */
  labelMode: _propTypes.default.string,
  isFullWidth: _propTypes.default.bool,
  isReadOnly: _propTypes.default.bool,
  value: _propTypes.default.any,
  error: _propTypes.default.any,
  className: _propTypes.default.string,
  customFields: _propTypes.default.object,
  onChange: _propTypes.default.func,
  onFocus: _propTypes.default.func,
  onBlur: _propTypes.default.func,
  onEnter: _propTypes.default.func,
  field: _propTypes.default.shape({
    label: _propTypes.default.string,
    labelMode: _propTypes.default.string,
    isFullWidth: _propTypes.default.bool,
    name: _propTypes.default.string,
    type: _propTypes.default.string,
    placeholder: _propTypes.default.string,
    hint: _propTypes.default.string,
    isRequired: _propTypes.default.bool,
    isReadOnly: _propTypes.default.bool,
    className: _propTypes.default.string,
    attrs: _propTypes.default.object
  }).isRequired
} : void 0;

var _default = /*#__PURE__*/_react.default.memo(FieldControl);

exports.default = _default;